<template>
  <span class="border shadow-inner bg-white p-2 rounded flex flex-gap-1 justify-between">
    <span>{{ href }}</span>
    <s-btn icon="content-copy" class="ml-2 h-fit" size="sm" color="blue-light" @click="copyLink">
      {{ t('buttons.copy') }}
    </s-btn>
  </span>
</template>
<script setup lang="ts">
import {useFlash} from '../../../composables/useFlash.js';
import SBtn from '../../../design-system/SBtn.vue';
import {useI18n} from 'vue-i18n';

const {href} = defineProps<{href: string}>();

const flash = useFlash();
const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});

const copyLink = () => {
  navigator.clipboard.writeText(href).then(() => {
    flash?.value.set('success', t('messages.copied'));

    setTimeout(() => {
      flash?.value?.dismiss('success');
    }, 5000);
  });
};
</script>
<i18n>
{
  "en": {
    "buttons.copy": "Copy",
    "messages.copied": "The dynamic registration link has been copied to your clipboard."
  },
  "fr": {
    "buttons.copy": "Copier",
    "messages.copied": "Le lien d'enregistrement dynamique a été copié dans votre presse-papiers."
  }
}
</i18n>
